import { CDataTable } from "@coreui/react";
import firebase from "firebase/compat/app";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LoadingSpinner, StepCard } from "src/components";
import { upperFirst } from "lodash";
import { StyledSuperTable } from "./SuperAdminPage.style";

const COLUMNS = [
  { label: "Organisation", key: "orgName" },
  { label: "Email", key: "email" },
  { label: "Standalone", key: "isStandalone" },
  { label: "Track", key: "track" },
  { label: "Joined At", key: "created" },
];

const getDate = (entry) => {
  return entry.created ? new Date(entry.created).toLocaleDateString() : "";
};

const EsgUsersPage = () => {
  const [rows, setRows] = React.useState([]);
  const [status, setStatus] = React.useState(true);

  const history = useHistory();

  const goToEsgDetails = (row) => {
    const { id, isStandalone, periodId } = row;

    history.push(
      `/survey/admin/users/${id}?standalone=${isStandalone}&periodId=${periodId}`
    );
  };

  useEffect(() => {
    const getData = async () => {
      setStatus("loading");

      try {
        const db = firebase.firestore();

        const standaloneOrgsSnapshot = await db
          .collectionGroup("esg-survey")
          .get();

        const standaloneRows = standaloneOrgsSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            orgName: data.orgName,
            email: data.email,
            id: data.id,
            isStandalone: true,
            track: upperFirst(data.track || ""),
            periodId: "",
            created: getDate(data),
            timestamp: data.created,
          };
        });

        const orgsSnapshot = await db
          .collection("organisations")
          .where("show-survey", "==", true)
          .get();

        const orgsRows = orgsSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            orgName: data.name,
            email: data["admin-email"],
            id: data.id,
            isStandalone: false,
            track: "",
            periodId: data.period,
            created: getDate(data),
            timestamp: data.created,
          };
        });

        const rows = [...standaloneRows, ...orgsRows].sort((a, b) => {
          return b.timestamp - a.timestamp;
        });

        setRows(rows);
        setStatus("success");
      } catch (e) {
        console.log(e);
        setStatus("error");
      }
    };

    getData();
  }, []);

  // console.log("data", data);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center mx-auto w-100"
      style={{ maxWidth: "1200px" }}
    >
      <h1 className="text-center my-4" style={{ fontWeight: "600" }}>
        ESG Survey
      </h1>
      {status === "loading" ? (
        <LoadingSpinner />
      ) : status === "error" ? (
        <h2 className="text-danger">There was an error loading users</h2>
      ) : (
        <StepCard>
          <h3 style={{ fontSize: "30px" }}>Users</h3>
          <p className="text-info">Click row to select</p>

          <StyledSuperTable className="w-100">
            <CDataTable
              fields={COLUMNS}
              items={rows}
              onRowClick={goToEsgDetails}
              hover
            />
          </StyledSuperTable>
        </StepCard>
      )}
    </div>
  );
};

export default EsgUsersPage;
